import metama from '~/components/icons/matama.vue';
import navatel from '~/components/icons/navatel.vue';
import navatelGrey from '~/components/icons/navatelGrey.vue';

import { h } from 'vue';

let customSvgNameToComponent: any = {
  navatel,
  navatelGrey,
  metama,
};

// for (const prefix in customIconSet) {
//   const newIcons: Partial<Record<keyof typeof icons, Component>> = {};
//   const icons = customIconSet[prefix as keyof typeof customIconSet].icons;

//   for (const key in icons) {
//     const icon = icons[key as keyof typeof icons];
//     newIcons[key as keyof typeof icons] = h(
//       'template',
//       null,
//       '<svg>' + icon.body + '</svg>'
//     );
//   }

customSvgNameToComponent = {
  ...customSvgNameToComponent,
  // ...newIcons,
};
// }
// console.log(customSvgNameToComponent);

const customIcons = {
  component: (props: any) => h(customSvgNameToComponent[props.icon]),
};

export { customIcons };
